



















import { Prop, Model, Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import UserMixin from '@/mixins/UserMixin';
import { BModal } from 'bootstrap-vue';
import _ from 'lodash';
import { IN2KWindEvent, N2KWindEventReference, IN2KRudderEvent, N2KRudderEventDirectionOrder, IN2KOutsideEnvironmentalEvent } from '@/common/apis/DeviceApi';
import { RadialGauge } from 'canvas-gauges';

export interface IAtmosphericPressureTileConfiguration { }

@Component({
    components: {
    },
})
export default class AtmosphericPressureTile extends Mixins(TileComponentMixin, UserMixin) {
    public fullscreen: boolean = false;

@Prop({required: false})
    public configuration?: IAtmosphericPressureTileConfiguration;

    public editConfiguration: IAtmosphericPressureTileConfiguration | null = null;


    public get available(): boolean {
        if (this.isPicker && !this.lastEvent) {
            return false;
        }
        return true;
    }

    public get lastEvent(): IN2KOutsideEnvironmentalEvent | null {
        let data = this.getOutsideEnvironmental(this.deviceNumber);
        if (!data && this.isDemo) {
            data = this.demoData || null;
        }
        return data;
    }
    public get ageInSeconds(): number {
        if (this.lastEvent && this.lastEvent.timestamp) {
            const timestamp = typeof this.lastEvent.timestamp === 'object'
                ? this.lastEvent.timestamp
                : new Date(this.lastEvent.timestamp);

            return (new Date().getDate() - timestamp.getDate()) / 1000;
        }
        return 999;
    }
    public get pressure(): number | null {
        return this.lastEvent && this.lastEvent.atmosphericPressure
            ? this.lastEvent.atmosphericPressure
            : null;
    }

    private chart?: RadialGauge;
    private chartOptions?: CanvasGauges.RadialGaugeOptions | null = null;
    private demoData: IN2KOutsideEnvironmentalEvent | null = null;
    private demoDataInterval: number;
    private redrawCount: number = 0;

    @Getter('n2k/outsideEnvironmental')
    private getOutsideEnvironmental: (deviceNumber: string) => IN2KOutsideEnvironmentalEvent | null;

    public save() {
        this.$emit('save', this.editConfiguration);
    }

    public async mounted() {
        if (this.isDemo) {
            this.generateDemoData();
            this.demoDataInterval = setInterval(this.generateDemoData, 1000);
        }

        if (!this.isPicker) {
            this.chartOptions = {
                renderTo: this.$refs.canvas as HTMLElement,
                startAngle: 70,
                ticksAngle: 220,
                minValue: 850,
                maxValue: 1150,
                majorTicks: ['850', '900', '950', '1000', '1050', '1100', '1150'],
                colorPlate: 'transparent',
                valueBox: false,
                borders: false,
                borderShadowWidth: 0,
                needleShadow: false,
                colorNumbers: '#FFF',
                colorBar: '#CCC',
                fontNumbersSize: 30,
                height: 130,
                width: 130,
                // units: 'bar',
                colorUnits: 'white',
                fontUnitsSize: 30,

                highlights: [
                    // {
                    //     from: 0.00,
                    //     to: 20.00,
                    //     color: '#EE9488',
                    // },
                ],
                colorMajorTicks: '#aaa',
                colorMinorTicks: '#aaa',
            };

            if (this.chartOptions && this.lastEvent && this.lastEvent.atmosphericPressure !== undefined) {
                this.chartOptions.value = this.lastEvent.atmosphericPressure;
            }

            this.chart = new RadialGauge(_.cloneDeep(this.chartOptions)).draw();
        }
    }
    public async beforeDestroy() {
        clearInterval(this.demoDataInterval);
        if (this.chart && this.chartOptions) {
            this.chart.destroy();
        }
    }

    @Watch('lastEvent')
    public updateChartValue() {
        if (this.chart && this.lastEvent && this.lastEvent.atmosphericPressure !== undefined) {
            this.chart.value = this.lastEvent.atmosphericPressure;
        }

        // Destry & Rebuild to avoid canvas crash on iOS
        this.redrawCount++;
        if (this.redrawCount > 500) {
            this.redrawCount = 0;
            if (this.chart && this.chartOptions) {
                this.chart.destroy();

                if (this.chartOptions && this.lastEvent && this.lastEvent.atmosphericPressure !== undefined) {
                    this.chartOptions.value = this.lastEvent.atmosphericPressure;
                }
                this.chart = new RadialGauge(_.cloneDeep(this.chartOptions)).draw();
            }
        }

    }

    private generateDemoData() {
        let atmosphericPressure = (this.demoData ? this.demoData.atmosphericPressure : undefined) || 1000 + (Math.random() * 50 - 25);
        atmosphericPressure += Math.random() * 200 - 100;
        if (atmosphericPressure > 1100) {
            atmosphericPressure = 1100;
        }
        if (atmosphericPressure < 900) {
            atmosphericPressure = 900;
        }
        this.demoData = {
            waterTemperature: 0,
            atmosphericPressure,
            deviceNumber: this.deviceNumber,
            timestamp: new Date(),
        };
    }

}
